import useStakePool from './hooks/useStakepool';

export enum Explorer {
    SOLSCAN = 'SOLSCAN',
}

export type StakePool = ReturnType<typeof useStakePool>['data'];
